import { call, put, takeLatest } from "redux-saga/effects";
import * as urls from "__utils/constants";
import { ResponseGeneratorType } from "__utils/types";
import * as api from "../__api";
import * as actionTypes from "./actionTypes";

const getBilling = function* (): any {
	try {
		const response: ResponseGeneratorType = yield call(api.getBillingAPI);
		const { status, data } = response;
		if (status === 200) {
			const { payment } = data.data;
			//             yield put(actions.setBillingData(billingDetails));
			yield put({
				type: actionTypes.GET_BILLING_SUCCESS,
				data: payment,
			});
		} else if (status === 302 || status === 403) {
			window.location.assign(urls.SIGN_IN_URL);
		} else {
			yield put({ type: actionTypes.GET_BILLING_FAILURE });
		}
	} catch (error) {
		yield put({ type: actionTypes.GET_BILLING_FAILURE });
	}
};

export const getBillingSaga = function* (): any {
	yield takeLatest(actionTypes.GET_BILLING, getBilling);
};
